export enum ClaimProcessingSystemName {
    ApproveClaim = 'approveclaim',
    ApproveClaimFinalise = 'approveClaimFinalise',
    RejectClaim = 'rejectclaim',
    SubmitClaim = 'submitclaim',
    ForceApproveClaim = 'forceApproveClaim'
}

export enum ClaimProcessingStatus {
    ClaimReceived = 'Claim Received',
    ClaimPending = 'Claim Pending',
    ClaimSubmitted = 'Claim Submitted',
    ClaimReturned = 'Claim Returned',
    ClaimApproved = 'Claim Approved'
};

export const ClaimProcessingActions = Object.values(ClaimProcessingSystemName) as string[];